import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductListGridInformation from "@SupplyLand/Widgets/ProductList/ProductListGridInformation";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = ProductCardSelections & HasProduct;

export interface ProductListGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
}

export const productGridCardStyles: ProductListGridCardStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            padding-bottom: 10px;
        `,
    },
    imageWrapper: {
        css: css`
            margin: auto;
            padding: 10px 50px;
        `,
    },
};

const styles = productGridCardStyles;

const ProductListGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showPrice,
}) => {
    return (
        <ProductListGridInformation
            showAttributes={false}
            showAvailability={false}
            showBrand={false}
            showPartNumbers={false}
            showTitle={showTitle}
        />
    );
};

export default withProduct(ProductListGridCard);
